export const environment = {
  production: true,
  e2e: false,
  raven: 'https://ea7f9b42688946b1a8b90d6e60d535a7@sentry.io/1265496'
};
